// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-tabs .mat-mdc-tab-group.mat-primary {
  border-bottom: none;
  --mat-tab-active-focus-label-text-color: var(--fi-color-default);
  --mat-tab-active-ripple-color: var(--branded-color);
  --mat-tab-inactive-ripple-color: var(--branded-color);
  --mat-tab-active-hover-label-text-color: var(--fi-color-default);
}
.fi-tabs .mat-mdc-tab-group.mat-primary .mdc-tab--active .mdc-tab__text-label {
  color: var(--branded-color);
}
.fi-tabs .mat-mdc-tab-group.mat-primary .mdc-tab-indicator .mdc-tab-indicator__content--underline {
  border-top-width: 3px;
}
.fi-tabs .mat-mdc-tab-group.mat-primary .mat-mdc-tab-label:focus:not(:active) {
  background-color: transparent;
  transition: background-color 0.2s;
}
.fi-tabs .mat-mdc-tab-group.mat-primary .mat-mdc-tab-label:active {
  transition: background-color 0.2s;
}
.fi-tabs .mat-mdc-tab-header {
  border-bottom: none !important;
  overflow: visible !important;
}

.page-section-error {
  position: absolute;
  display: inline-block;
  border: 0px;
  top: 10px;
  line-height: 1;
  background-color: inherit;
  z-index: 1;
  right: -10px;
  left: auto;
}
.page-section-error .asteriskCcmIcon:before {
  font-size: 100%;
}
.page-section-error .angle {
  display: none;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-shared-styles/fi-tabs-mixin.scss","webpack://./Source/app/utilities/tabs/tabs.component.scss"],"names":[],"mappings":"AACI;EACI,mBAAA;EACA,gEAAA;EACA,mDAAA;EACA,qDAAA;EACA,gEAAA;ACAR;ADEQ;EACI,2BAAA;ACAZ;ADGQ;EACI,qBAAA;ACDZ;ADIQ;EACI,6BAAA;EACA,iCAAA;ACFZ;ADIQ;EACI,iCAAA;ACFZ;ADMI;EACI,8BAAA;EACA,4BAAA;ACJR;;AAjBA;EACI,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,yBAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;AAoBJ;AAnBI;EACI,eAAA;AAqBR;AAnBI;EACI,aAAA;AAqBR","sourcesContent":["@mixin fi-tabs {\r\n    .mat-mdc-tab-group.mat-primary {\r\n        border-bottom: none;\r\n        --mat-tab-active-focus-label-text-color: var(--fi-color-default);\r\n        --mat-tab-active-ripple-color: var(--branded-color);\r\n        --mat-tab-inactive-ripple-color: var(--branded-color);\r\n        --mat-tab-active-hover-label-text-color: var(--fi-color-default);\r\n\r\n        .mdc-tab--active .mdc-tab__text-label {\r\n            color: var(--branded-color);\r\n        }\r\n\r\n        .mdc-tab-indicator .mdc-tab-indicator__content--underline {\r\n            border-top-width: 3px;\r\n        }\r\n\r\n        .mat-mdc-tab-label:focus:not(:active) {\r\n            background-color: transparent;\r\n            transition: background-color 0.2s;\r\n        }\r\n        .mat-mdc-tab-label:active {\r\n            transition: background-color 0.2s;\r\n        }\r\n    }\r\n\r\n    .mat-mdc-tab-header {\r\n        border-bottom: none !important;\r\n        overflow: visible !important;\r\n    }\r\n}\r\n","@use '../../shared/fi-shared-styles/fi-tabs-mixin';\r\n\r\n.fi-tabs {\r\n    @include fi-tabs-mixin.fi-tabs;\r\n}\r\n\r\n.page-section-error {\r\n    position: absolute;\r\n    display: inline-block;\r\n    border: 0px;\r\n    top: 10px;\r\n    line-height: 1;\r\n    background-color: inherit;\r\n    z-index: 1;\r\n    right: -10px;\r\n    left: auto;\r\n    .asteriskCcmIcon:before {\r\n        font-size: 100%;\r\n    }\r\n    .angle {\r\n        display: none;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
